import styled from 'styled-components';

export const Svg = styled.svg``;
export const Rect = styled.rect``;
